export default __webpack_public_path__ + "static/media/stamped.4242e41e.png";